require('./mortgageRequestSimpleNoteConstructions.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { get, isEmpty } = require('lodash');
const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;

// @ utilities
const { addOrdinal } = require('utilities/stringHelper');
const { getEstatesToRequest } = require('utilities/mortgageHelper');

//@ components
const MortgageRequestSimpleNoteAddress = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteAddressFormat/mortgageRequestSimpleNoteAddressFormat');

// @ constants
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData');

class MortgageRequestSimpleNoteConstructions extends React.Component {
    constructor(props) {
        super(props);

        this.buildAddressWrapper = this.buildAddressWrapper.bind(this);
        this.buildUdifirWrapper = this.buildUdifirWrapper.bind(this);
        this.buildDataRegister = this.buildDataRegister.bind(this);
        this.validateContent = this.validateContent.bind(this);
    }

    buildAddressWrapper(item) {
        return (
            <MortgageRequestSimpleNoteAddress
                completeItem={item}
                showLivingPlaceLabel={false}
            />
        );
    }

    buildFormattedTextDataRegister(item, getItemProperty, key) {
        let formattedTextItem;

        if (get(item, getItemProperty)) {
            formattedTextItem = (
                <FormattedText
                    value={key}
                    injectedStrings={[get(item, getItemProperty, '')]}
                />
            );
        }

        return formattedTextItem;
    }

    buildDataRegister(item) {
        const province = this.buildFormattedTextDataRegister(item, 'provincia', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_province');
        const population = this.buildFormattedTextDataRegister(item, 'poblacion', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_population');
        const populationId = this.buildFormattedTextDataRegister(item, 'populationId', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_populationId');
        const realEstate = this.buildFormattedTextDataRegister(item, 'numeroFinca', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_realEstate');
        const seccion = this.buildFormattedTextDataRegister(item, 'seccion', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_seccion');
        const registerBook = this.buildFormattedTextDataRegister(item, 'registerBook', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_registerBook');
        const registerVolume = this.buildFormattedTextDataRegister(item, 'registerVolume', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_registerVolume');
        const registerFolio = this.buildFormattedTextDataRegister(item, 'registerFolio', 'mortgageRequestSimpleNoteConstructions-mortgageRequestSimpleNoteConstructions_registerFolio');

        return (
            <div className="mortgage-request-simple-note-constructions__description">
                {province}{population}
                <br />
                {populationId}{realEstate}
                <br />
                {seccion}{registerBook}{registerVolume}{registerFolio}
            </div>
        );
    }

    buildItem(idx, item) {
        let suffix = '';

        if (item.tipoBien === ESTATES_TYPE.GARAJE) {
            suffix = `${addOrdinal(getLanguage(), idx)} ${formatText('mortgageRequestSimpleNoteConstructions-garage')}`;
        } else if (item.tipoBien === ESTATES_TYPE.TRASTERO) {
            suffix = `${addOrdinal(getLanguage(), idx)} ${formatText('mortgageRequestSimpleNoteConstructions-storageRoom')}`;
        }

        const validations = this.validateContent(item);

        return (
            <div key={item.bienId}
                className="mortgage-request-simple-note-constructions__item">
                <span className="mortgage-request-simple-note-constructions__label">
                    {suffix}
                </span>

                {validations.hasLivingPlace && this.buildAddressWrapper(item)}

                {validations.hasUdifir && this.buildUdifirWrapper(item)}

                {validations.hasRegisterData && this.buildDataRegister(item)}

            </div>
        );
    }

    buildUdifirWrapper(item) {
        const udifir = get(item, 'udifir', '');

        return (
            <div>
                <p className="mortgage-request-simple-note-constructions__description">
                    {udifir}
                </p>
            </div>
        );
    }

    validateContent(item) {
        const validations = {
            hasLivingPlace: false,
            hasUdifir: false,
            hasRegisterData: false
        }

        const udifir = get(item, 'udifir', '');

        if (item.tipoVia && item.calleBien && item.numeroCalle) {
            validations.hasLivingPlace = true;
        } else if (udifir) {
            validations.hasUdifir = true;
        } else if (!validations.hasLivingPlace && !validations.hasUdifir) {
            validations.hasRegisterData = true;
        }

        return validations;
    }

    render() {
        const { immEstates, showTitle } = this.props;
        const estatesToRequest = getEstatesToRequest(immEstates);
        const estatesToRequestHTML = estatesToRequest.map((estate, idx) => this.buildItem(++idx, estate));
        const otherEstatesTitle = showTitle && !isEmpty(estatesToRequestHTML) && (
            <span className="mortgage-request-simple-note-constructions__title">
                {formatText('mortgageRequestSimpleNoteConstructions-otherEstates')}
            </span>
        );

        return (
            <div className="mortgage-request-simple-note-constructions">
                {otherEstatesTitle}
                {estatesToRequestHTML}
            </div>
        );
    }
}

MortgageRequestSimpleNoteConstructions.propTypes = {
    immEstates: PropTypes.object.isRequired,
    showTitle: PropTypes.bool
};

MortgageRequestSimpleNoteConstructions.defaultProps = {
    showTitle: true
};

module.exports = MortgageRequestSimpleNoteConstructions;
